/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharereviewcolumnstep3Inputs */

const en_sharereviewcolumnstep3 = /** @type {(inputs: Sharereviewcolumnstep3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Step`)
};

const de_sharereviewcolumnstep3 = /** @type {(inputs: Sharereviewcolumnstep3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schritt`)
};

/**
* | output |
* | --- |
* | "Step" |
*
* @param {Sharereviewcolumnstep3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharereviewcolumnstep3 = /** @type {((inputs?: Sharereviewcolumnstep3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharereviewcolumnstep3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharereviewcolumnstep3(inputs)
	return de_sharereviewcolumnstep3(inputs)
});
export { sharereviewcolumnstep3 as "shareReviewColumnStep" }